import React from 'react';
import { Flex } from '@abyss/web/ui/Flex';
import { Label } from '@abyss/web/ui/Label';
import { Link } from '@abyss/web/ui/Link';
import { styled } from '@abyss/web/tools/styled';
import { IFooterList } from './interfaces/IFooterList';

interface FooterListPrimaryProps {
  data: IFooterList[];
}

const StyledFlex = styled(Flex, {
    marginRight: '50px!important'
});
const StyledLink = styled(Link, {
    marginTop: '10px!important'
});

const FooterListPrimary: React.FC<FooterListPrimaryProps> = ({
  data,
}: FooterListPrimaryProps) => {
  return (
    <Flex direction="row">
      {data.map((item) => {
        return (
          <StyledFlex direction="column" key={item.key}>
            <Label size="md" color="$primary2">
              {item.Heading}
            </Label>
            {item.Links.map((innerItem) => {
              return (
                <StyledLink
                hideIcon 
                  key={innerItem.key}
                  size="xs"
                  color="$primary2"
                  href={innerItem.Url}
                >
                  {innerItem.Text}
                </StyledLink>
              );
            })}
          </StyledFlex>
        );
      })}
    </Flex>
  );
};

export { FooterListPrimary };
